import { IKimAddress } from '@alberta/konexi-shared';
import { Injectable } from '@angular/core';
import { SelectionItem } from 'src/app/shared/models/selectionItem';
import { AccountService } from 'src/app/shared/services/account.service';
import { resolveKimAddressLabel } from 'src/app/shared/services/kim/kim-address-label';

/**
 * Loads the logged-in user's own KIM addresses as selection items
 * (label includes the mailbox display name configured on the organization when known).
 */
@Injectable({ providedIn: 'root' })
export class KimSenderAddressService {
  constructor(private _accountService: AccountService) {}

  public async getSenderSelectionItems(): Promise<SelectionItem[]> {
    const account = await this._accountService.getAccount();
    const userKimAddresses = account?.kimAddresses ?? [];
    if (!userKimAddresses.length) {
      return [];
    }

    const organization = await this._accountService.getCurrentUserOrganization();
    const organizationKimAddresses: IKimAddress[] = organization?.alberta?.kimAddresses ?? [];
    return userKimAddresses.map(
      kimAddress => new SelectionItem(kimAddress, resolveKimAddressLabel(kimAddress, organizationKimAddresses))
    );
  }
}
